module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__("react-dom");

// EXTERNAL MODULE: external "@carvana/futilities"
var futilities_ = __webpack_require__("@carvana/futilities");

// CONCATENATED MODULE: ./src/Portal.tsx
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var Portal_Portal =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Portal, _Component);

  function Portal(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.bodyElem = void 0;
    _this.modalContainer = void 0;

    if (Object(futilities_["isServerSideRendering"])()) {
      return _assertThisInitialized(_this);
    }

    _this.bodyElem = document.body;
    _this.modalContainer = document.createElement('div');

    _this.modalContainer.classList.add(props.rootClassname);

    return _this;
  }

  var _proto = Portal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (Object(futilities_["isServerSideRendering"])()) {
      return;
    }

    var open = this.props.open;

    if (open) {
      this.open();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (Object(futilities_["isServerSideRendering"])()) {
      return;
    }

    var open = this.props.open;

    if (!prevProps.open && open) {
      this.open();
    }

    if (prevProps.open && !open) {
      this.close();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (Object(futilities_["isServerSideRendering"])()) {
      return;
    }

    var open = this.props.open;

    if (open) {
      this.close();
    }
  };

  _proto.close = function close() {
    if (!this.bodyElem || !this.modalContainer) return;
    this.bodyElem.style.removeProperty('overflow');
    this.bodyElem.style.removeProperty('padding-right');

    if (this.bodyElem.contains(this.modalContainer)) {
      this.bodyElem.removeChild(this.modalContainer);
    }
  };

  _proto.open = function open() {
    if (!this.bodyElem || !this.modalContainer) return;
    var size = Object(futilities_["getScrollBarSize"])();
    this.bodyElem.style.overflow = 'hidden';
    this.bodyElem.style.paddingRight = size + "px";
    this.bodyElem.appendChild(this.modalContainer);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        open = _this$props.open;
    var shouldRenderPortal = open && !Object(futilities_["isServerSideRendering"])();
    return shouldRenderPortal ? Object(external_react_dom_["createPortal"])(children, this.modalContainer) : null;
  };

  return Portal;
}(external_react_["Component"]);

/* harmony default export */ var src_Portal = (Portal_Portal);
// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@carvana/icons/Close"
var Close_ = __webpack_require__("@carvana/icons/Close");
var Close_default = /*#__PURE__*/__webpack_require__.n(Close_);

// CONCATENATED MODULE: ./src/modal/Modal.styles.tsx


var ModalBackdrop = external_styled_components_default.a.div.withConfig({
  displayName: "ModalBackdrop",
  componentId: "mhin9-0"
})(["position:fixed;top:0;right:0;bottom:0;left:0;margin:auto;width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;background:rgba(24,53,88,0.3);z-index:1050;"]);
var ModalContent = external_styled_components_default.a.div.withConfig({
  displayName: "ModalContent",
  componentId: "mhin9-1"
})(["position:fixed;right:0;left:0;top:50%;transform:translateY(-50%);width:100%;border-radius:3px;max-width:", ";margin:0 auto;background:", ";height:", ";z-index:1051;overflow-y:auto;@media (min-width:768px){max-height:95vh;max-width:704px;height:auto;}"], function (props) {
  return props.fullscreenOnMobile ? '100%' : '320px';
}, function (props) {
  return props.whiteBg ? props.theme.carvana.white.primary : props.theme.carvana.gray.background;
}, function (props) {
  return props.fullscreenOnMobile ? '100%' : 'auto';
});
var HeaderContainer = external_styled_components_default.a.div.withConfig({
  displayName: "HeaderContainer",
  componentId: "mhin9-2"
})(["position:sticky;top:0;color:", ";background:", ";padding:15px 0;box-shadow:0px 2px 4px -1px rgba(25,41,61,0.18);z-index:300;@media (min-width:768px){position:relative;border-top-right-radius:3px;border-top-left-radius:3px;}"], function (props) {
  return props.theme.carvana.blue.dark;
}, function (props) {
  return props.theme.carvana.white.primary;
});
var ModalHeader = external_styled_components_default.a.h5.withConfig({
  displayName: "ModalHeader",
  componentId: "mhin9-3"
})(["font-size:14px;line-height:1;font-weight:700;text-transform:uppercase;text-align:center;margin:0 auto;@media (min-width:768px){font-size:16px;}"]);
var ModalCloseButton = external_styled_components_default.a.div.withConfig({
  displayName: "ModalCloseButton",
  componentId: "mhin9-4"
})(["width:14px;height:14px;position:absolute;top:0;bottom:0;margin:auto;right:15px;cursor:pointer;line-height:1;"]);
var CloseIcon = external_styled_components_default()(Close_default.a).withConfig({
  displayName: "CloseIcon",
  componentId: "mhin9-5"
})(["> svg{width:13px;height:13px;}"]);

// CONCATENATED MODULE: ./src/modal/Modal.props.ts

var defaultProps = {
  disableBackdropClick: false,
  whiteBg: false,
  className: '',
  showHeader: true,
  headerText: '',
  fullscreenOnMobile: false,
  Header: ModalHeader,
  Content: ModalContent,
  Backdrop: ModalBackdrop,
  CloseButton: ModalCloseButton
};
// CONCATENATED MODULE: ./src/modal/Modal.tsx





function Modal(_ref) {
  var children = _ref.children,
      open = _ref.open,
      headerText = _ref.headerText,
      toggleModal = _ref.toggleModal,
      disableBackdropClick = _ref.disableBackdropClick,
      whiteBg = _ref.whiteBg,
      showHeader = _ref.showHeader,
      className = _ref.className,
      modalTestName = _ref.modalTestName,
      fullscreenOnMobile = _ref.fullscreenOnMobile,
      Header = _ref.Header,
      Content = _ref.Content,
      Backdrop = _ref.Backdrop,
      CloseButton = _ref.CloseButton;
  return external_react_default.a.createElement(src_Portal, {
    open: open,
    rootClassname: "modal-root"
  }, external_react_default.a.createElement(Backdrop, {
    "data-cv-test": "Modal.Backdrop",
    onClick: function onClick(e) {
      return disableBackdropClick ? null : toggleModal(e);
    }
  }), external_react_default.a.createElement(Content, {
    whiteBg: whiteBg,
    className: className,
    "data-cv-test": modalTestName,
    fullscreenOnMobile: fullscreenOnMobile
  }, showHeader ? external_react_default.a.createElement(HeaderContainer, null, external_react_default.a.createElement(Header, null, headerText), external_react_default.a.createElement(CloseButton, {
    onClick: toggleModal,
    "aria-label": "Close Modal"
  }, external_react_default.a.createElement(CloseIcon, null))) : null, children));
}

Modal.defaultProps = defaultProps;
/* harmony default export */ var modal_Modal = (Modal);
// CONCATENATED MODULE: ./src/modal/useModal.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var useModal_useModal = function useModal() {
  var _useState = Object(external_react_["useState"])(false),
      open = _useState[0],
      setOpen = _useState[1];

  var closeModal = function closeModal() {
    return setOpen(false);
  };

  var openModal = function openModal() {
    return setOpen(true);
  };

  var ModalWrapper = Object(external_react_["memo"])(function (_ref) {
    var children = _ref.children,
        props = _objectWithoutPropertiesLoose(_ref, ["children"]);

    return external_react_default.a.createElement(modal_Modal, _extends({}, props, {
      open: open,
      toggleModal: closeModal
    }), children);
  });
  ModalWrapper.defaultProps = defaultProps;
  return {
    Modal: ModalWrapper,
    closeModal: closeModal,
    openModal: openModal
  };
};

/* harmony default export */ var modal_useModal = (useModal_useModal);
// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport Modal */__webpack_require__.d(__webpack_exports__, "Modal", function() { return modal_Modal; });
/* concated harmony reexport useModal */__webpack_require__.d(__webpack_exports__, "useModal", function() { return modal_useModal; });
/* concated harmony reexport ModalHeader */__webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return ModalHeader; });
/* concated harmony reexport ModalContent */__webpack_require__.d(__webpack_exports__, "ModalContent", function() { return ModalContent; });
/* concated harmony reexport ModalBackdrop */__webpack_require__.d(__webpack_exports__, "ModalBackdrop", function() { return ModalBackdrop; });
/* concated harmony reexport ModalCloseButton */__webpack_require__.d(__webpack_exports__, "ModalCloseButton", function() { return ModalCloseButton; });




/* harmony default export */ var src = __webpack_exports__["default"] = (modal_Modal);

/***/ }),

/***/ "@carvana/futilities":
/***/ (function(module, exports) {

module.exports = require("@carvana/futilities");

/***/ }),

/***/ "@carvana/icons/Close":
/***/ (function(module, exports) {

module.exports = require("@carvana/icons/Close");

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-dom":
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map